var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tipo==="label-circulo")?_c('el-tooltip',{attrs:{"effect":"light","placement":"top","content":_vm.texto}},[_c('div',{class:[_vm.tipo, "label"],style:(_vm.estilo)})]):(_vm.tipo==="label-barra")?_c('div',{class:[_vm.tipo, "label"],style:(_vm.estilo)},[_vm._v(_vm._s(_vm.texto))]):_c('div',{style:(_vm.estilo)},[_vm._v(_vm._s(_vm.texto))])
}
var staticRenderFns = []

export { render, staticRenderFns }